import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  textPart: {
    width: '100%',
    marginTop: -160,
    padding: '0 50px',
    textAlign: 'center',
    color: theme.colors.light.freshPowder,
  },
  title: {
    margin: '50px 0 25px',
    fontSize: 32,
    fontWeight: 500,
    color: theme.colors.light.lightCyan,
  },
  subTitle: {
    color: theme.colors.light.lightSteelBlue,
    fontSize: theme.fonts.sizes.font16PX,
    fontWeight: 500,
  },
}));

export const useStylesButton = makeStyles(theme => ({
  root: {
    width: '100%',
    height: 46,
    marginTop: 26,
    color: theme.colors.light.freshPowder,
    backgroundColor: theme.colors.orange.orange,
    '&:hover': {
      backgroundColor: theme.colors.orange.orange,
    },
  },
}));
